'use strict';

var selectors = {
    wishlistValid: '.is-wishlist-valid',
    wishlistUrl: '.wishlist-client-url',
    wishlistEnabled: '.is-wishlist-enabled'
};

var requestStates = {
    pending: 'pending',
    loaded: 'loaded',
    error: 'error'
};

/**
 * Fetches and maintains wishlist.
 */
var wishlistStore = {

    init() {
        this.wishlistUrl = this.getWishlistUrl();
        this.state = requestStates.pending;
        this.items = null;
    },

    isReady() {
        return this.state === requestStates.loaded;
    },

    getWishlistData() {
        var deferred = $.Deferred();
        this.getWishlistFromServer(deferred);

        return deferred;
    },

    getWishlistUrl() {
        var wishlistUrlElement = document.querySelector(selectors.wishlistUrl);

        return wishlistUrlElement ? wishlistUrlElement.value || '' : '';
    },

    getWishlistFromServer(deferred) {
        if (!this.wishlistUrl) {
            deferred.reject(new Error('Wishlist URL not found'));
            return;
        }

        $.ajax({
            url: this.wishlistUrl,
            method: 'GET',
            success: this.handleServerResponse.bind(this, deferred),
            error: this.handleServerError.bind(this, deferred)
        });
    },

    handleServerResponse(deferred, response) {
        if (!response || !response.items) {
            deferred.reject(new Error('Received invalid data'));
            return;
        }

        var items = response.items;

        this.items = items;
        this.state = requestStates.loaded;

        $(document).on('wishlist-mutation', this.handleWishlistMutation.bind(this));

        deferred.resolve(items);
    },

    handleServerError(deferred) {
        this.state = requestStates.error;
        deferred.reject(new Error('Error on HTTP request'));
    },

    handleWishlistMutation(event, data) {
        if (!data) {
            return;
        }

        var productId = data.productId || null;
        var added = typeof data.added === 'boolean' ? data.added : null;

        if (typeof productId !== 'string' || typeof added !== 'boolean') {
            return;
        }

        if (added) {
            this.items.push(productId);
        } else {
            this.items = this.items.filter(function (item) {
                return item !== productId;
            });
        }
    }

};

/**
 * Public interface.
 */
var wishlistHelper = {

    // Methods for public use.

    init() {
        if (this.isInitialized) {
            return this;
        }

        this.isInitialized = true;
        this.isRelevant = this.determineRelevance();
        this.readyListeners = [];

        if (!this.isRelevant) {
            return this;
        }

        // Fetch wishlist if relevant.
        wishlistStore.init();
        wishlistStore.getWishlistData()
            .done(this.handleWishlistReady.bind(this))
            .fail(this.handleWishlistError.bind(this));

        return this;
    },

    callOnReady(callback) {
        if (wishlistStore.isReady()) {
            this.callListeners([callback]);
        } else if (this.readyListeners.indexOf(callback) === -1) {
            this.readyListeners.push(callback);
        }
    },

    // Methods for private use.

    determineRelevance() {
        // Wishlist not relevant for user when not logged in.
        var isValidElement = document.querySelector(selectors.wishlistValid);

        if (!isValidElement) {
            return false;
        }

        // Wishlist not relevant when disabled via site preference.
        var isEnabledElement = document.querySelector(selectors.wishlistEnabled);
        var isEnabled = isEnabledElement ? (isEnabledElement.value || '').trim() === 'true' : false;

        if (!isEnabled) {
            return false;
        }

        // Wishlist heart will never be shown on mobile breakpoint.
        // No need to bother there with updating wishlist hearts.
        var mobileMax = 992;

        return !(window.screen.width < mobileMax && window.screen.height < mobileMax);
    },

    callListeners(listeners) {
        var items = wishlistStore.items;

        for (var i = 0; i < listeners.length; i += 1) {
            var listener = listeners[i];

            try {
                listener(items);
            } catch (e) {
                if (window.console) {
                    window.console.error(e);
                }
            }
        }
    },

    handleWishlistReady() {
        this.callListeners(this.readyListeners);
    },

    handleWishlistError(error) {
        if (window.console) {
            window.console.error('Error on fetching wishlist: ', error);
        }
    }

};

module.exports = wishlistHelper;
